export enum CarrotPlanMediaTypeId {
  Article = "article",
  Video = "video",
  Guide = "guide",
  Group = "groupSession"
}

type CarrotPlanMediaType = {
  stepVal: string
  replacement: string
  displayNameWithArticle: string
  menuItemId: string
}

export const CarrotPlanMediaTypes: { [key in CarrotPlanMediaTypeId]: CarrotPlanMediaType } = {
  [CarrotPlanMediaTypeId.Article]: {
    stepVal: 'Read "[article title]"',
    replacement: "[article title]",
    displayNameWithArticle: "an article",
    menuItemId: "6P6c1JhtDMcVIk9DE8u1Ca"
  },
  [CarrotPlanMediaTypeId.Video]: {
    stepVal: 'Watch "[video title]"',
    replacement: "[video title]",
    displayNameWithArticle: "a video",
    menuItemId: "6cjqRZ2djmEpFH1eD0elbX"
  },
  [CarrotPlanMediaTypeId.Guide]: {
    stepVal: 'Explore "[guide title]"',
    replacement: "[guide title]",
    displayNameWithArticle: "a guide",
    menuItemId: "20nMPmMswstXjq3xdBXEzi"
  },
  [CarrotPlanMediaTypeId.Group]: {
    stepVal: 'Attend a group session on "[group title]"',
    replacement: "[group title]",
    displayNameWithArticle: "a group",
    menuItemId: "1D4fLW2eWfCnRGd3v0z2Wx"
  }
}

const allMediaTypes = Object.entries(CarrotPlanMediaTypes) as [CarrotPlanMediaTypeId, CarrotPlanMediaType][]

export const carrotPlanMediaMenuItemIds = allMediaTypes.map(([, t]) => t.menuItemId)

const menuItemIdToTypeId = new Map<string, CarrotPlanMediaTypeId>(allMediaTypes.map(([id, t]) => [t.menuItemId, id]))

export const getCarrotPlanMediaTypeIdForMenuItemId = (menuItemId: string | undefined): CarrotPlanMediaTypeId | null => {
  if (menuItemId == null) return null
  return menuItemIdToTypeId.get(menuItemId) ?? null
}

export const getCarrotPlanMediaReplacementForMenuItemId = (menuItemId: string | undefined): string | undefined => {
  const mediaTypeId = getCarrotPlanMediaTypeIdForMenuItemId(menuItemId)
  return mediaTypeId ? CarrotPlanMediaTypes[mediaTypeId].replacement : undefined
}

export const resolveMenuItemDisplayLabel = (
  menuItemId: string,
  displayText: string,
  mediaItemTitle: string | null | undefined
): string => {
  if (!mediaItemTitle) return displayText
  const replacement = getCarrotPlanMediaReplacementForMenuItemId(menuItemId)
  if (replacement && displayText.includes(replacement)) {
    return displayText.replace(replacement, () => mediaItemTitle)
  }
  return displayText
}
